module.exports = __webpack_public_path__ + "img/Cardboard_pile_of_boxes_art_illustration 1.3c97b0e9.svg";